import { EditableComponent } from '@adobe/aem-react-editable-components';
import { useWishlistModalStore } from '../../modules/store/wishlistModalStore';
import { WishListDetailView } from './WishlistDetailView';

export * from './WishlistDetailView';

export const WishlistDetailsConfig = {
  emptyLabel: 'wishlistdetails',
  isEmpty: () => false,
  resourceType: 'mi-aem-account/components/content/wishlistdetails',
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const WishlistDetailsEditable = (props: any) => {
  const { model, isAuthorMode, ...editableProps } = props;
  const { wishlistId } = useWishlistModalStore(state => state);

  if (!wishlistId) {
    return null;
  }

  return (
    <EditableComponent config={WishlistDetailsConfig} {...editableProps}>
      <WishListDetailView authoredProp={model} isAuthorMode={isAuthorMode} />
    </EditableComponent>
  );
};
